import {
  parseCapitalRequirements,
  type CapitalRequirements,
} from "../../tastyworks/capital-requirements"
import type HttpClient from "../../tastyworks/http"
import type { RequestOptions } from "../../tastyworks/http"
import {
  extractErrorMessage,
  parseSingleResponse,
} from "../../tastyworks/response"

const REQUEST_FAILED_MESSAGE = "Capital requirements request failed"

export class CapitalRequirementsService {
  private readonly marginAccountClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.marginAccountClient = baseHttpClient.nested(
      "margin/accounts/:accountNumber"
    )
  }

  readonly show = async (
    accountNumber: string,
    options?: RequestOptions
  ): Promise<CapitalRequirements> => {
    const { helper, ok } = await this.marginAccountClient.getWithStatus(
      "requirements",
      { accountNumber },
      undefined,
      options
    )
    const response = parseSingleResponse(helper, parseCapitalRequirements)
    if (!ok || response.isError || !response.hasData()) {
      throw new Error(extractErrorMessage(response) ?? REQUEST_FAILED_MESSAGE)
    }

    return response.data
  }
}
